import React from 'react';
import Icon from './Icon';

export default class IconDefault extends Icon {
    renderIcon() {
        return (
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                <defs>
                    <style></style>
                </defs>
                <g transform="translate(-697.999 -1601)">
                    <g transform="translate(-512 625)">
                        <g transform="translate(-376.121 976)">
                            <g className="a" fill="#f0f2f7" stroke="#9da4b3" transform="translate(1586.12 0)">
                                <circle className="d" stroke="none" cx="12" cy="12" r="12"/>
                                <circle className="b" fill="none" cx="12" cy="12" r="11.5"/>
                            </g>
                        </g>
                    </g>
                    <g transform="translate(701.41 1604.411)">
                        <path className="b" fill="none" d="M0,0H17.178V17.178H0Z"/>
                        <path className="c" fill="#4d5e80"
                              d="M9.726,4.779V6.06a.354.354,0,0,0,.608.251l2-2a.354.354,0,0,0,0-.508l-2-2a.358.358,0,0,0-.608.258V3.348A5.724,5.724,0,0,0,4,9.074a5.6,5.6,0,0,0,.408,2.111.717.717,0,0,0,1.174.243.688.688,0,0,0,.165-.744,4.168,4.168,0,0,1-.315-1.61A4.3,4.3,0,0,1,9.726,4.779Zm4.144,1.94a.691.691,0,0,0-.165.744,4.291,4.291,0,0,1-3.98,5.9V12.087a.354.354,0,0,0-.608-.251l-2,2a.354.354,0,0,0,0,.508l2,2a.357.357,0,0,0,.608-.251V14.8a5.724,5.724,0,0,0,5.726-5.726,5.6,5.6,0,0,0-.408-2.111.717.717,0,0,0-1.174-.243Z"
                              transform="translate(-1.137 -0.485)"/>
                    </g>
                </g>
            </svg>
        );
    }
}